// Calendario de festivos de Colombia.
//
// Reglas aplicadas:
//  - Festivos de fecha fija (no se trasladan).
//  - Ley Emiliani (51 de 1983): algunos festivos se corren al lunes siguiente.
//  - Festivos derivados de la Pascua: Jueves y Viernes Santo caen en su dia real;
//    Ascension, Corpus Christi y Sagrado Corazon se trasladan al lunes.
//
// Se usa para calcular los dias habiles del termino legal de respuesta de un PQR.

const cache = {}

// Algoritmo de Gauss/Meeus para el Domingo de Pascua.
function domingoPascua (year) {
  const a = year % 19
  const b = Math.floor(year / 100)
  const c = year % 100
  const d = Math.floor(b / 4)
  const e = b % 4
  const f = Math.floor((b + 8) / 25)
  const g = Math.floor((b - f + 1) / 3)
  const h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4)
  const k = c % 4
  const l = (32 + 2 * e + 2 * i - h - k) % 7
  const m = Math.floor((a + 11 * h + 22 * l) / 451)
  const mes = Math.floor((h + l - 7 * m + 114) / 31)
  const dia = ((h + l - 7 * m + 114) % 31) + 1
  return new Date(year, mes - 1, dia)
}

function sumarDias (fecha, dias) {
  const d = new Date(fecha)
  d.setDate(d.getDate() + dias)
  return d
}

// Ley Emiliani: si no cae lunes, se corre al lunes siguiente.
function trasladarALunes (fecha) {
  const dow = fecha.getDay()
  if (dow === 1) return fecha
  // domingo (0) suma 1; el resto suma lo que falte para llegar al lunes.
  return sumarDias(fecha, dow === 0 ? 1 : 8 - dow)
}

function clave (fecha) {
  return `${fecha.getFullYear()}-${fecha.getMonth()}-${fecha.getDate()}`
}

function festivosDelAnio (year) {
  if (cache[year]) return cache[year]

  const pascua = domingoPascua(year)

  const fijos = [
    new Date(year, 0, 1),    // Ano nuevo
    new Date(year, 4, 1),    // Dia del trabajo
    new Date(year, 6, 20),   // Independencia
    new Date(year, 7, 7),    // Batalla de Boyaca
    new Date(year, 11, 8),   // Inmaculada Concepcion
    new Date(year, 11, 25),  // Navidad
    sumarDias(pascua, -3),   // Jueves Santo
    sumarDias(pascua, -2)    // Viernes Santo
  ]

  const trasladables = [
    new Date(year, 0, 6),    // Reyes Magos
    new Date(year, 2, 19),   // San Jose
    new Date(year, 5, 29),   // San Pedro y San Pablo
    new Date(year, 7, 15),   // Asuncion de la Virgen
    new Date(year, 9, 12),   // Dia de la Raza
    new Date(year, 10, 1),   // Todos los Santos
    new Date(year, 10, 11),  // Independencia de Cartagena
    sumarDias(pascua, 43),   // Ascension del Senor
    sumarDias(pascua, 64),   // Corpus Christi
    sumarDias(pascua, 71)    // Sagrado Corazon
  ].map(trasladarALunes)

  const set = new Set([...fijos, ...trasladables].map(clave))
  cache[year] = set
  return set
}

export function esFestivo (fecha) {
  return festivosDelAnio(fecha.getFullYear()).has(clave(fecha))
}

// Habil = lunes a viernes que no sea festivo nacional.
export function esDiaHabil (fecha) {
  const dow = fecha.getDay()
  if (dow === 0 || dow === 6) return false
  return !esFestivo(fecha)
}

// Dias habiles transcurridos entre dos fechas (sin contar el dia de inicio).
// Se acota el recorrido para que una fecha corrupta no cueste miles de iteraciones.
export function diasHabilesEntre (desde, hasta, maxDias = 400) {
  if (!desde || !hasta) return 0

  // Se ancla al mediodia y no a medianoche: si el navegador esta en una zona
  // con cambio de horario, medianoche puede no existir y el cursor se corre una
  // hora, cortando el recorrido un dia antes. Al mediodia el dia nunca cambia.
  const inicio = new Date(desde)
  inicio.setHours(12, 0, 0, 0)
  const fin = new Date(hasta)
  fin.setHours(12, 0, 0, 0)

  if (fin <= inicio) return 0

  let habiles = 0
  let recorridos = 0
  const cursor = new Date(inicio)

  while (cursor < fin && recorridos < maxDias) {
    cursor.setDate(cursor.getDate() + 1)
    recorridos++
    if (esDiaHabil(cursor)) habiles++
  }

  return habiles
}
